import React, { useState } from "react";
import "../../styles/profile.css";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";

// Functional component for the Home page
const FaqEdit = () => {
  return (
    <div className="container-fluid page_background ">
      <div className="page-inner-content mb-3">
        <div className="page_inner_content_box">
          <Formik>
            <>
              <Form>
                <h5 className="mb-4 main-heading-title">Edit FAQ</h5>
                <div
                  className="card redeam_bottom_card"
                  style={{
                    borderTopLeftRadius: "12px",
                    borderTopRightRadius: "12px",
                  }}
                >
                  <div className="row form_body justify-content-center">
                    <div className="col-xl-7 col-lg-10 col-md-10 my-2">
                      <div className="row  mb-2">
                        <div className="col-lg-5 col-md-6 col-sm-5">
                          <label htmlFor="otp" className="form-label">
                            Question
                          </label>
                        </div>
                        <div className="col-lg-7 col-md-6 col-sm-7">
                          <Field
                            as="textarea" // Use textarea instead of text input
                            rows="3" // Define the height of the textarea
                            className="form-control"
                            id="question"
                            name="question"
                            placeholder="Enter Question"
                          />
                        </div>
                      </div>
                      <div className="row  mb-2">
                        <div className="col-lg-5 col-md-6 col-sm-5">
                          <label htmlFor="otp" className="form-label">
                            Answer
                          </label>
                        </div>
                        <div className="col-lg-7 col-md-6 col-sm-7">
                          <Field
                            as="textarea"
                            rows="10"
                            type="text"
                            className="form-control"
                            id="answer"
                            name="answer"
                            placeholder="Enter Answer"
                            style={{ height: "auto" }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-footer form_card form_card_border">
                  <div className="d-flex justify-content-between gap-2">
                    <button type="button" className="form_button ">
                      Cancel
                    </button>
                    <button type="submit" className="form_button next_btn">
                      Update
                    </button>
                  </div>
                </div>
              </Form>
            </>
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default FaqEdit;
